import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function CaretRightIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 16 16">
      <path d="m10.964 8.103-5 5a.375.375 0 0 1-.53-.53l4.734-4.735-4.734-4.735a.375.375 0 0 1 .53-.53l5 5a.375.375 0 0 1 0 .53Z" fill="currentColor" stroke="currentColor" />
    </BaseIcon>
  )
}
